export default "__VITE_ASSET__BnY14sjJ__"